import Vue from 'vue';
import HTTP from '../../utils/http.js';
import getSerialisedParams from '../../utils/getSerialisedParams.js';
import BaseCount from '../../mixins/BaseCount/BaseCount.js';

/**
 * Hey!
 *
 * SLineCount component used for Line social network
 * @link https://line.me/
 */
/**
 * Share parameters for link
 * @link https://social-plugins.line.me/en/how_to_install#lineitbutton
 */

var SLineCount = /* #__PURE__ */Vue.extend({
  name: 'SLineCount',
  mixins: [BaseCount('Line')],
  methods: {
    handlePinterestResponse: function handlePinterestResponse(data) {
      this.handleResult(data);
      this.handleCount(data.share);
    }
  },
  mounted: function mounted() {
    var _this = this;

    var shareOptions = this.shareOptions;
    var url = shareOptions.url;
    var BASE_URL = 'https://api.line.me/social-plugin/metrics';
    var finalURL = "".concat(BASE_URL).concat(getSerialisedParams({
      url: url
    }));
    this.handleLoading(true);
    HTTP(finalURL, function (err, data) {
      _this.handleLoading(false);

      if (err) {
        _this.handleError(err);
      }

      if (data) {
        _this.handlePinterestResponse(data);
      }
    });
  }
});

export default SLineCount;
